//Class qui contient les fontions par défaut des scènes.

import { tags } from '../consts/Tags.js'
// import SoundManager from '../prefabs/SoundManager.js';

export default class AbstractScene extends Phaser.Scene {

    //Initialisation par défaut, à ajouter dans tous les initialisation
    //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
    _init(data) {
        console.log('Start :', this.scene.key, data);
        this.data = {};

        this.game.data.sceneRunning = this.scene.key;
        // this.soundManager = new SoundManager();

        if (data) {
            // Data à faire passer au besoin
        }
    }

    //Preload de la scene par défaut, initialise les variables utiles
    _preload() {

        this.width = this.cameras.main.width; //Largeur de l'écran
        this.height = this.cameras.main.height; //Hauter de l'écran

        this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
        this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran
    }

    nextScene() {
        var sceneInfo = this.game.data[this.game.data.sceneRunning];
        this.scene.start(sceneInfo.next, this.data);
    }

    clone(element) {
        var clone = Phaser.Utils.Objects.Clone(element)
        this.add.existing(clone)
        return clone
    }

    createTextElement(x, y, element) {
        let txt = this.add.rexTagText(x, y, element.text, {
            fontSize: element.config.size,
            fontFamily: element.config.fontFamily,
            align: element.config.align,
            color: element.config.color,
            backgroundColor: element.config.backColor,
            wordWrap: { width: element.config.width },
            tags: tags
        }).setOrigin(element.config.origin.x, element.config.origin.y);
        return txt
    }

    tweenTextColor(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target.style, 'color', to, duration, (color => {
            if(target.scene != undefined)
                target.setColor(Phaser.Display.Color.RGBToString(color.r, color.g, color.b, 0, '#'));
        }));
    }

    tweenShapeColor(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target, 'fillColor', to, duration);
    }

    tweenImageTint(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target, 'tint', to, duration);
    }

    tweenPropertyColorOnUpdate(target, property, to, duration, funcToExecOnUPdate = null) {
        let colorFrom = Phaser.Display.Color.ValueToColor(target[property]);
        let colorTo = Phaser.Display.Color.ValueToColor(to);
        this.tweens.add({
            targets: colorFrom,
            r: colorTo.red,
            g: colorTo.green,
            b: colorTo.blue,
            duration: duration,
            ease: 'Power2',
            onUpdate: () => {
                target[property] = Phaser.Display.Color.GetColor(colorFrom.r, colorFrom.g, colorFrom.b);
                if (funcToExecOnUPdate) {
                    funcToExecOnUPdate(colorFrom);
                }
            },
        })
    }
}